/**
 * Mobile-only slider for the "Multicolumn with icon" (USP) section.
 *
 * Mirrors the theme's existing slider pattern (see button-list /
 * buttons-with-icon-list.js) but is inverted: the Swiper is initialized on
 * MOBILE and destroyed on desktop, where the normal grid is used.
 *
 * Activated only when the section renders <multicolumn-icon data-mobile-slider="true">.
 * Swiper classes are added/removed by JS so the desktop grid stays untouched.
 */
if (!customElements.get('multicolumn-icon')) {
  class MulticolumnIcon extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = false;
    }

    connectedCallback() {
      if (this.dataset.mobileSlider !== 'true') return;

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
        swiperSlide: 'swiper-slide',
      };

      this.wrapper = this.querySelector('.multicolumn__items');
      if (!this.wrapper) return;
      this.slides = Array.from(this.wrapper.children);
      if (this.slides.length < 2) return;

      this.init();
      document.addEventListener('matchMobile', () => this.init());
      document.addEventListener('unmatchMobile', () => this.init());
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (typeof this.sliderInstance === 'object' || !window.FoxTheme?.Swiper) return;

      this.classList.add(this.classes.swiper);
      this.wrapper.classList.remove(this.classes.grid);
      this.wrapper.classList.add(this.classes.swiperWrapper);
      this.slides.forEach((slide) => slide.classList.add(this.classes.swiperSlide));

      const options = {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        grabCursor: true,
        threshold: 2,
        watchOverflow: false,
      };

      const modules = [];
      const autoplayEnabled = this.dataset.autoplay === 'true' && !FoxTheme.config.motionReduced;
      if (autoplayEnabled) {
        modules.push(FoxTheme.Swiper.Autoplay);
        options.autoplay = {
          delay: (parseFloat(this.dataset.autoplaySpeed) || 3.5) * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        };
      }

      this.sliderInstance = new window.FoxTheme.Carousel(this, options, modules);
      this.sliderInstance.init();

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.dataset.sectionId) return;
          const index = Number(e.target.dataset.index);
          if (!isNaN(index)) this.sliderInstance.slider.slideToLoop(index);
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.wrapper.classList.remove(this.classes.swiperWrapper);
      this.wrapper.classList.add(this.classes.grid);
      this.slides.forEach((slide) => slide.classList.remove(this.classes.swiperSlide));
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }

  customElements.define('multicolumn-icon', MulticolumnIcon);
}
